import { FeatureFlag } from '@ps/web-core-enums';
import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import useFeature from '@swf/core/hooks/useFeature';
import { select } from '@swf/core/store';

import { CashoutMethodType } from '../../../../types/Cashier';
import { CardType } from '../../../../types/cardType';
import {
  withdrawCreditTimeGroupFour,
  withdrawCreditTimeGroupOne,
  withdrawCreditTimeGroupThree,
  withdrawCreditTimeGroupTwo
} from '../../data';

import {
  TXTWCL_Instant_6,
  TXTWCL_N0_business_days,
  TXTWCL_This_is_usually_instant,
  TXTWCL_Up_to_1_hour,
  TXTWCL_Up_to_N0_business_days,
  TXTWCL_Up_to_N0_days,
  TXTWCL_Up_to_N0_hours
} from './WithdrawCreditTime.messages.json';
import { infoBoxMs, message } from './WithdrawCreditTime.scss';

export const getWithdrawCreditTime = (
  type: CardType,
  isOverCredit?: boolean,
  _isUSLicense?: boolean,
  showOverCreditTime?: boolean
) => {
  if (type === CardType.Interac) return isOverCredit && showOverCreditTime ? 3 : 24;
  if (withdrawCreditTimeGroupTwo.includes(type)) return isOverCredit && showOverCreditTime ? 7 : 4;
  if (withdrawCreditTimeGroupThree.includes(type))
    return isOverCredit && showOverCreditTime ? 8 : 5;
  if (withdrawCreditTimeGroupFour.includes(type))
    return isOverCredit && showOverCreditTime ? 13 : 10;

  return 3;
};
interface Props {
  cardType: CardType;
  methodType?: CashoutMethodType;
  showBusinessDaysOnly?: boolean;
  inPanelDesc?: boolean;
  inDetailsPanel?: boolean;
  showOverCreditTime?: boolean;
}

const getCreditTimeLabel = (
  cardType: CardType,
  methodType?: CashoutMethodType,
  showBusinessDaysOnly?: boolean,
  showOverCreditTime?: boolean
) => {
  if (showBusinessDaysOnly) {
    return TXTWCL_N0_business_days;
  }

  if (cardType === CardType.OpenBanking && !showOverCreditTime) {
    return methodType === CashoutMethodType.Rollback ? TXTWCL_Instant_6 : TXTWCL_Up_to_1_hour;
  }

  if (cardType === CardType.Interac && !showOverCreditTime) {
    return TXTWCL_Up_to_N0_hours;
  }

  if (withdrawCreditTimeGroupOne.includes(cardType) && !showOverCreditTime) {
    return TXTWCL_Instant_6;
  }

  if (methodType === CashoutMethodType.Rollback && withdrawCreditTimeGroupOne.includes(cardType)) {
    return TXTWCL_This_is_usually_instant;
  }

  return showOverCreditTime ? TXTWCL_Up_to_N0_days : TXTWCL_Up_to_N0_business_days;
};

const WithdrawCreditTime: React.FC<Props> = ({
  cardType,
  methodType,
  showBusinessDaysOnly,
  inPanelDesc,
  inDetailsPanel,
  showOverCreditTime
}) => {
  const isUSLicense = useSelector(select.account.isUSLicense);
  const withdrawalCreditTimeEnabled = useFeature(FeatureFlag.SwcWithdrawalCreditTime);

  return withdrawalCreditTimeEnabled ? (
    <span className={!inDetailsPanel ? (inPanelDesc ? infoBoxMs : message) : ''}>
      <Translation
        {...getCreditTimeLabel(cardType, methodType, showBusinessDaysOnly, showOverCreditTime)}
        values={{
          0: getWithdrawCreditTime(
            cardType,
            methodType === CashoutMethodType.OverCredit,
            isUSLicense,
            showOverCreditTime
          )
        }}
      />
    </span>
  ) : null;
};

export default WithdrawCreditTime;
